import React, { useContext, useState, useEffect } from 'react'

import { useFormik } from 'formik'
import { Button } from '@mui/material'
import CustomTable from '@/product/components/molecules/CustomTable'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import CustomDialog from '@/product/components/organisms/Dialog'
import ProductContext from '@/product/context/product/productContext'
import BidContext from '@/product/context/bid/bidContext'
import CommonContext from '@/product/context/common/commonContext'
import ReportContext from '@/product/context/report/reportContext'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import { currencyFormat } from '@/custom/common/components'

const OfferHistory = (props) => {
    const productContext = useContext(ProductContext)
    const bidContext = useContext(BidContext)
    const {
        search_allbidhistory,
        getAllBidHistory,
        clearResponse: clearAllBidHistory,
    } = productContext
    const {
        bidCancel,
        bidAward,
        responseStatus: responseStatusBid,
    } = bidContext

    const [changeStatus, setChangeStatus] = useState(false)
    const [successModal, setSuccessModal] = useState(false)
    const [selectedUserDetails, setSelectedUserDetails] = useState([])
    const [firstBidder, setFirstBidder] = useState(false)

    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const changeSuccessModal = () => {
        setSuccessModal(!successModal)
    }

    const commonContext = useContext(CommonContext)
    const { bidHistoryValue, clearBidHistoryValue } = commonContext

    const { getAllExportDownload } = useContext(ReportContext)

    const [tableBody, setTableBody] = useState([])
    const [projectData, setProjectData] = useState(null)
    const [data, setData] = useState({
        popup: false,
        status: 'new',
        id: 0,
    })

    const [showDeclined, setShowDeclined] = useState(false)
    const toggleDecline = () => {
        formikData.values.page = 1
        setShowDeclined(!showDeclined)
        formikData.values.declined = !showDeclined
        getAllBidHistory(formikData.values)
    }

    const formikData = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            get_proxy: false,
            declined: false,
            delete_bid: false,
            award_bid: false,
            show_declined: false,
            project: props.project || 'NPS',
            filters: {
                project_id: {
                    value: 0,
                    type: 'in',
                    field: 'b.project_id',
                },
                user_id: {
                    value: '',
                    type: 'in',
                    field: 'b.user_id',
                },
                proposal: {
                    value: 'tie_bid',
                    type: 'notin',
                    field: 'b.proposal',
                },
                auctionid: {
                    field: 'p.auctionid',
                    value: '',
                    type: 'in',
                },
                market_status: {
                    field: 'p.market_status',
                    type: 'arrayinmultiple',
                    value: '',
                },
            },
        },
        onSubmit: (values) => {
            getCreditHistory(values)
        },
    })

    useEffect(() => {
        if (bidHistoryValue) {
            if (bidHistoryValue.id) {
                formikData.values.page = 1
                formikData.values.filters.project_id.value = bidHistoryValue.id
                formikData.values.get_proxy = bidHistoryValue.proxy || false
                formikData.values.filters.auctionid.value = ''
                formikData.values.filters.market_status.value = ''
                if (bidHistoryValue.declined) {
                    formikData.values.declined =
                        bidHistoryValue.declined || false
                } else {
                    formikData.values.declined = false
                }
                formikData.values.delete_bid =
                    bidHistoryValue.delete_bid &&
                    bidHistoryValue.delete_bid === true
                        ? true
                        : false
                formikData.values.award_bid =
                    bidHistoryValue.award_bid &&
                    bidHistoryValue.award_bid === true
                        ? true
                        : false

                formikData.values.show_declined =
                    bidHistoryValue.show_declined &&
                    bidHistoryValue.show_declined === true
                        ? true
                        : false
                if (bidHistoryValue.user_id) {
                    formikData.values.filters.user_id.value =
                        bidHistoryValue.user_id
                } else {
                    formikData.values.filters.user_id.value = ''
                }
                if (
                    bidHistoryValue.getBidByAuction &&
                    global.additionalBidHistory
                ) {
                    formikData.values.get_bid_auction = true
                    formikData.values.filters.project_id.value = ''
                    formikData.values.filters.auctionid.value =
                        bidHistoryValue.id
                    if (bidHistoryValue.market_status == 'closed') {
                        formikData.values.filters.market_status.value =
                            'sold,closed'
                        formikData.values.filters.market_status.type =
                            'arrayinmultiple'
                    } else {
                        formikData.values.filters.market_status.value =
                            bidHistoryValue.market_status
                        formikData.values.filters.market_status.type = 'in'
                    }
                } else {
                    formikData.values.get_bid_auction = false
                    formikData.values.filters.auctionid.value = ''
                }
                if (bidHistoryValue.show_tiebid) {
                    formikData.values.filters.proposal.value = ''
                } else {
                    formikData.values.filters.proposal.value = 'tie_bid'
                }
            } else {
                formikData.values.page = 1
                formikData.values.filters.project_id.value = bidHistoryValue
            }
            if (bidHistoryValue.offer) {
                setData({ popup: true, id: bidHistoryValue })
                getAllBidHistory(formikData.values)
                clearBidHistoryValue()
                setShowDeclined(false)
            }
            //console.log(bidHistoryValue, 'bidHistoryValue')
        }
        return () => {
            clearBidHistoryValue()
            setShowDeclined(false)
        }
    }, [bidHistoryValue])

    useEffect(() => {
        if (search_allbidhistory) {
            if (search_allbidhistory.records.length) {
                search_allbidhistory.records.map((item) => {
                    if (item.bidtopstatus) {
                        item.bidtopstatus =
                            item.bidtopstatus == 'lost'
                                ? 'Lost'
                                : item.bidtopstatus == 'won'
                                  ? 'Won'
                                  : item.bidtopstatus == 'winner'
                                    ? 'Winning'
                                    : item.bidtopstatus == 'outbid'
                                      ? 'Currently Outbid'
                                      : 'No Bids'
                    }
                })

                setTableBody(search_allbidhistory.records)
            } else {
                setTableBody([])
                //setTableBody(search_allbidhistory.records.length ? search_allbidhistory.records : [])
            }

            if (search_allbidhistory.projectRecords) {
                setProjectData(search_allbidhistory.projectRecords)
            }
        }
    }, [search_allbidhistory])

    let tableValues = [
        {
            field: 'user_id',
            type: '',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'User ID',
        },
        // {
        //     field: 'users_first_name,users_last_name',
        //     type: '',
        //     sort: false,
        //     firstChild: false,
        //     disablePadding: false,
        //     label: 'Username',
        // },
        {
            field: 'users_companyname',
            type: '',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Company Name',
        },
        // {
        //     field: 'users_email',
        //     type: '',
        //     sort: false,
        //     firstChild: false,
        //     disablePadding: false,
        //     label: 'User Email',
        // },
        {
            field: 'created_at',
            type: 'datetimesecond',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Date',
        },
    ]

    if (formikData.values.declined) {
        tableValues.push({
            field: 'bidtext',
            condition: true,
            conditionValue: {
                formula: {
                    key1: 'declined',
                    key2: 1,
                    notation: '===',
                },
                true: {
                    type: 'text',
                    value: 'Retracted',
                },
                false: {
                    type: 'text',
                    value: 'Valid',
                },
            },
            type: 'text',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Status',
        })
        if (formikData.values.project === 'NPS') {
            tableValues.push({
                field: 'bid_retract_logs_created_at',
                type: 'datetime',
                firstChild: false,
                sort: false,
                disablePadding: false,
                label: 'Retracted On',
            })
            tableValues.push({
                field: 'brl_first_name,brl_last_name',
                type: 'text',
                firstChild: false,
                sort: false,
                disablePadding: false,
                label: 'Retracted By',
            })
        }
    }

    if (formikData.values.get_proxy) {
        tableValues.push({
            field: 'bidtext',
            condition: true,
            conditionValue: {
                formula: {
                    key1: 'proxytable',
                    key2: 1,
                    notation: '===',
                },
                true: {
                    type: 'text',
                    value: 'Max',
                },
                false: {
                    type: 'value',
                    value: 'bidText',
                },
            },
            type: 'text',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Type',
        })
    }

    tableValues.push({
        field: 'proposed_amount',
        type: 'price',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: 'Offer Price',
    })

    if (formikData.values.award_bid) {
        if (projectData && projectData.market_status === 'open') {
        } else if (projectData && projectData.market_status === 'relisted') {
            tableValues.push({
                field: 'bidtext',
                condition: true,
                conditionValue: {
                    formula: {
                        key1: 'awarded',
                        key2: 1,
                        notation: '===',
                    },
                    true: {
                        type: 'text',
                        value: 'Moved to Auction',
                    },
                    false: {
                        type: 'text',
                        value: 'Moved to Auction',
                    },
                },
                type: 'text',
                sort: true,
                firstChild: false,
                disablePadding: false,
                label: 'Type',
            })
        } else {
            tableValues.push({
                field: 'bidtext',
                condition: true,
                conditionValue: {
                    formula: {
                        key1: 'awarded',
                        key2: 1,
                        notation: '===',
                    },
                    true: {
                        type: 'text',
                        value: 'Winner',
                    },
                    false: {
                        type: 'text',
                        value: 'Lost',
                    },
                },
                type: 'text',
                sort: true,
                firstChild: false,
                disablePadding: false,
                label: 'Type',
            })
        }
    }
    if (formikData.values.get_bid_auction && global.additionalBidHistory) {
        tableValues = global.additionalBidHistory
    }

    const formikSelection = useFormik({
        initialValues: {
            action: '',
            id: '',
            pid: '',
        },
        onSubmit: (values) => {
            if (values.action === 'delete') {
                // setIsLoading(true)
                bidCancel(values)
            } else if (values.action === 'award') {
                // setIsLoading(true)
                bidAward(values)
            }
        },
    })

    const onClickEdit = (id, secondaryID, type) => {
        formikSelection.values.action = type
        formikSelection.values.id = id
        formikSelection.values.pid = formikData.values.filters.project_id.value
        if (type === 'delete' || type === 'award') {
            setChangeStatus(true)
        }
    }

    const getMultipleAction = () => {
        let actionPush = []
        if (formikData.values.delete_bid && !showDeclined) {
            actionPush.push({
                field: 'action',
                type: 'button',
                clickType: 'delete',
                onclick: onClickEdit,
                sort: false,
                firstChild: false,
                disablePadding: false,
                label: 'Action',
                tooltipTitle: 'Delete Bid',
                buttonType: 'delete',
            })
        }

        if (formikData.values.award_bid) {
            if (projectData && projectData.market_status === 'open') {
                actionPush.push({
                    field: 'action',
                    type: 'button',
                    clickType: 'award',
                    onclick: onClickEdit,
                    sort: false,
                    firstChild: false,
                    disablePadding: false,
                    label: 'Action',
                    tooltipTitle: 'Award User',
                    buttonType: 'check_circle',
                })
            }
        }

        return actionPush
    }
    if (
        (formikData.values.delete_bid && !showDeclined) ||
        (formikData.values.award_bid &&
            projectData &&
            projectData.market_status === 'open' &&
            !showDeclined)
    ) {
        let actionIndex = tableValues.findIndex((e) => e.field === 'action')
        if (actionIndex === -1) {
            tableValues.push({
                name: 'action',
                field: 'action',
                type: 'button',
                isMultiple: true,
                clickID: 'id',
                sort: false,
                firstChild: false,
                disablePadding: false,
                label: 'Action',
                isMultiple: getMultipleAction(),
                tableShow: 1,
            })
        }
    }

    useEffect(() => {
        if (responseStatusBid) {
            if (
                responseStatusBid.from === 'bidCancel' ||
                responseStatusBid.from === 'bidAward'
            ) {
                if (responseStatusBid.status === 'success') {
                    changeChangeStatus()
                    if (responseStatusBid.from === 'bidAward') {
                        changeSuccessModal()
                    }
                    getAllBidHistory(formikData.values)
                }
            }
        }
    }, [responseStatusBid])

    const tableActions = []

    let warHouse = []
    let warHouseExport = {}
    if (formikData.values.get_bid_auction && global.additionalBidHistory) {
        global.additionalBidHistory.map((spaceDog) => {
            warHouse.push({
                name: spaceDog.label,
                field: spaceDog.field,
                type: 'text',
            })
            warHouseExport[spaceDog.field] = {
                name: spaceDog.label,
                field: spaceDog.field,
                type: 'text',
            }
        })
    }

    useEffect(() => {
        let topBidder = false
        if (tableBody.length) {
            let orderedTableBody = tableBody.sort((a, b) =>
                a.proposed_amount < b.proposed_amount ? 1 : -1
            )
            if (orderedTableBody.length) {
                if (
                    parseInt(orderedTableBody[0].id, 10) !==
                    parseInt(formikSelection?.values?.id, 10)
                ) {
                    topBidder = true
                }
            }
        }

        setSelectedUserDetails(
            tableBody
                ?.filter((d) => formikSelection?.values?.id == d.id)
                .map((data) => data)[0]
        )

        setFirstBidder(topBidder)
    }, [formikSelection?.values?.id])

    return (
        data.popup && (
            <>
                <CustomDialog
                    title="Offer History"
                    className="offerHistoryModal"
                    open={data.popup === true}
                    function={() => setData({ ...data, popup: false })}
                >
                    <div className="offerHistoryModalInner">
                        <div className="ohInfoCnt">
                            <h5 className="ohInfo">
                                Lot Id: <span>{projectData?.auction_lot}</span>
                            </h5>
                            <h5 className="ohInfo">
                                Lot Title: <span>{projectData?.title}</span>
                            </h5>
                            <h5 className="ohInfo">
                                Cost Price:{' '}
                                <span>
                                    {currencyFormat(projectData?.cost_price)}
                                </span>
                            </h5>
                        </div>
                        {/* <Button
                            id="offer_history"
                            onClick={() =>
                                getAllExportDownload({
                                    action: 'export',
                                    order: 'asc',
                                    orderby: '',
                                    search: formikData.values.get_bid_auction
                                        ? `p.auctionid=${formikData.values.filters.auctionid.value}`
                                        : `b.project_id=${formikData.values.filters.project_id.value}`,
                                    report: `bid_history`,
                                    get_bid_auction: formikData.values
                                        .get_bid_auction
                                        ? true
                                        : false,
                                    report_action: formikData.values
                                        .get_bid_auction
                                        ? 'download'
                                        : '',
                                    projectID:
                                        formikData.values.filters.project_id
                                            .value,
                                    showAuctionName: true,
                                    fields: warHouseExport,
                                    market_status:
                                        formikData.values.filters.market_status
                                            .value,
                                })
                            }
                        >
                            {' '}
                            <span className="material-icons">get_app</span>
                            Export All Data
                        </Button> */}

                        {formikData.values.show_declined ? (
                            <div className="text-left">
                                <FormControlLabel
                                    id={'show_declined'}
                                    label={'Show Retracted Offers'}
                                    control={
                                        <Switch
                                            checked={showDeclined}
                                            onChange={toggleDecline}
                                        />
                                    }
                                />
                            </div>
                        ) : null}

                        <CustomTable
                            formik={formikData.values}
                            tableBody={tableBody}
                            tableValues={tableValues}
                            tableActions={tableActions}
                            allData={search_allbidhistory}
                            changeTableFunction={getAllBidHistory}
                            hideCompactView={true}
                        />
                    </div>
                </CustomDialog>
                <CustomDialog
                    // title={'Change Bid Status'}
                    open={changeStatus}
                    function={changeChangeStatus}
                    className="cnfOfferModal"
                >
                    <div className="cnfOfferInner">
                        {formikSelection.values.action === 'award' ? (
                            <>
                                {firstBidder ? (
                                    <h6 className="notHighestBidWarn">
                                        <span className="material-icons">
                                            warning
                                        </span>
                                        Attention! The user you&apos;re awarding
                                        does not hold the highest offer. Are you
                                        certain you want to proceed?
                                    </h6>
                                ) : null}
                                <h5>
                                    Are you sure you would like to award{' '}
                                    <span>{projectData?.auction_lot}</span> to{' '}
                                    <span>
                                        {selectedUserDetails?.users_companyname}
                                    </span>
                                    ?
                                </h5>
                                <h6>
                                    Offer Price:{' '}
                                    <span>
                                        {currencyFormat(
                                            selectedUserDetails?.proposed_amount
                                        )}{' '}
                                        per carat
                                    </span>
                                </h6>
                            </>
                        ) : (
                            <h5>Are you sure you want to delete the bid</h5>
                        )}
                    </div>

                    <div className="actionWrapper">
                        <SecondaryButton
                            id="bidHistory_cancel"
                            onClick={() => changeChangeStatus()}
                            label="No, Cancel"
                        />

                        <form
                            onSubmit={formikSelection.handleSubmit}
                            autoComplete="nofill"
                        >
                            <PrimaryButton
                                id="bidHistory_submit"
                                type="submit"
                                label="Yes, Confirm"
                            />
                        </form>
                    </div>
                </CustomDialog>
                <CustomDialog
                    // title={'Change Bid Status'}
                    open={successModal}
                    function={changeSuccessModal}
                    className="cnSuccessModal"
                >
                    <div className="offerSuccessInner">
                        <img src="/assets/images/check.png" alt="Success" />
                        <h5>
                            <span>{projectData?.auction_lot}</span> has been
                            successfully awarded to{' '}
                            <span>
                                {selectedUserDetails?.users_companyname}
                            </span>{' '}
                            for an offer price of{' '}
                            <span>
                                {' '}
                                {currencyFormat(
                                    selectedUserDetails?.proposed_amount
                                )}{' '}
                                per carat.
                            </span>
                        </h5>
                    </div>
                </CustomDialog>
            </>
        )
    )
}

export default OfferHistory
